/*
  DIVAZ cart drawer (replaces the UpCart app).
  Mounted by snippets/dz-cart.liquid when window.DZ_CART is on. That snippet also removes the theme's own
  quick cart + purchase-confirmation popup and leaves a hidden ".quick-cart" stub, so the Cornerstone theme
  keeps adding to cart over AJAX (its product form only does that when a .quick-cart exists) while nothing of
  the theme opens. Every cart change made on the page (theme forms, quick add, apps) is picked up by watching
  /cart/add|change|update|clear requests; adds open the drawer. Content is server-rendered by
  sections/dz-cart-drawer.liquid, recommendations by sections/dz-cart-recs.liquid.
*/
(function () {
  if (!window.DZ_CART || window.__dzCartLoaded) return;
  window.__dzCartLoaded = true;

  var SECTION = 'dz-cart-drawer';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var baseFetch = window.fetch.bind(window);
  var armedAt = Infinity;
  function arm() { armedAt = performance.now() + 500; }
  if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm);

  function el() { return document.getElementById('DzCart'); }
  function json(r) { return r.json(); }
  function post(path, body, withSection) {
    if (withSection) { body.sections = [SECTION]; body.sections_url = window.location.pathname; }
    return baseFetch(ROOT + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(json);
  }

  var changedOnCartPage = false;
  var Cart = {
    isOpen: function () { var d = el(); return !!(d && d.classList.contains('is-open')); },
    open: function () {
      var d = el(); if (!d || this.isOpen()) return;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('dzc-lock');
      var c = d.querySelector('.dzc-close'); if (c) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 60);
    },
    close: function () {
      var d = el(); if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('dzc-lock');
      if (this.lastFocus && this.lastFocus.focus) { try { this.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      if (changedOnCartPage) window.location.reload();
    },
    loading: function (on) { var d = el(); if (d) d.classList.toggle('is-loading', !!on); },
    render: function (html) {
      var d = el(); if (!html || !d) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-dzc-body]'), cur = d.querySelector('[data-dzc-body]');
      if (!fresh || !cur) return;
      var scroll = cur.querySelector('[data-dzc-scroll]'), top = scroll ? scroll.scrollTop : 0;
      cur.replaceWith(fresh);
      var ns = fresh.querySelector('[data-dzc-scroll]'); if (ns) ns.scrollTop = top;
      loadRecs(fresh);
    },
    refresh: function () {
      return baseFetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(json).then(function (d) { Cart.render(d && d[SECTION]); }).catch(function () {});
    },
    after: function (d) {
      if (d && d.sections && d.sections[SECTION]) Cart.render(d.sections[SECTION]); else Cart.refresh();
      refreshHeader();
      if (/\/cart\/?$/.test(window.location.pathname)) changedOnCartPage = true;
    },
    change: function (line, qty) {
      Cart.loading(true);
      return post('cart/change.js', { line: line, quantity: Math.max(0, qty) }, true)
        .then(Cart.after).catch(function () { Cart.refresh(); })
        .then(function () { Cart.loading(false); });
    },
    add: function (id, btn) {
      if (btn) btn.setAttribute('aria-busy', 'true');
      Cart.loading(true);
      return post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }, true)
        .then(Cart.after).catch(function () { Cart.refresh(); })
        .then(function () { Cart.loading(false); if (btn) btn.removeAttribute('aria-busy'); });
    }
  };
  window.DzCart = Cart;

  /* header cart count / subtotal label: same refresh the theme does after its own cart updates */
  function refreshHeader() {
    var h = document.querySelector('[data-section-type="header"]');
    var sec = h && h.closest('.shopify-section');
    if (!sec || !sec.id) return;
    var id = sec.id.replace(/^shopify-section-/, '');
    baseFetch(ROOT + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelectorAll('[data-header-cart]'), cur = document.querySelectorAll('[data-header-cart]');
        for (var i = 0; i < cur.length && i < fresh.length; i++) cur[i].innerHTML = fresh[i].innerHTML;
        for (var j = 0; j < cur.length && j < fresh.length; j++) {
          if (fresh[j].hasAttribute('data-cart-count')) cur[j].setAttribute('data-cart-count', fresh[j].getAttribute('data-cart-count'));
        }
      }).catch(function () {});
  }

  /* recommendations ("Ți-ar putea plăcea și") */
  var recsCache = {};
  function loadRecs(body) {
    var box = body && body.querySelector('[data-dzc-upsells]');
    if (!box) return;
    var pid = body.getAttribute('data-first-product'), url = body.getAttribute('data-recs-url');
    if (!pid || !url) return;
    var key = pid + '|' + body.getAttribute('data-cart-products');
    var p = recsCache[key] || (recsCache[key] = baseFetch(url + '?product_id=' + pid + '&limit=10&intent=related&section_id=dz-cart-recs', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }));
    p.then(function (html) {
      if (!html || !document.body.contains(box)) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var slides = doc.querySelectorAll('.dzc-slide');
      if (!slides.length) { box.hidden = true; return; }
      var track = box.querySelector('[data-dzc-track]');
      track.innerHTML = '';
      slides.forEach(function (s) { track.appendChild(document.importNode(s, true)); });
      box.hidden = false;
      box.__slide = 0; goSlide(box, 0);
    });
  }
  function goSlide(box, i) {
    var slides = box.querySelectorAll('.dzc-slide'), n = slides.length;
    var k = n ? ((i % n) + n) % n : 0; box.__slide = k;
    var car = box.querySelector('[data-dzc-carousel]'); if (car) car.setAttribute('data-count', n);
    var track = box.querySelector('[data-dzc-track]'); if (track) track.style.transform = 'translateX(' + (-100 * k) + '%)';
    var b = box.querySelectorAll('[data-dzc-slide]');
    for (var x = 0; x < n; x++) slides[x].toggleAttribute('inert', x !== k);
  }

  /* note */
  var noteTimer = null;
  function saveNote(v) { post('cart/update.js', { note: v }, false).catch(function () {}); }

  /* drawer events (delegated) */
  document.addEventListener('click', function (e) {
    var d = el(); if (!d || !d.contains(e.target)) return;
    var t = e.target;
    if (t.closest('[data-dzc-close]')) { e.preventDefault(); Cart.close(); return; }
    var item = t.closest('[data-line]');
    var step = t.closest('[data-dzc-step]');
    if (step && item) {
      var input = item.querySelector('[data-dzc-input]');
      Cart.change(Number(item.getAttribute('data-line')), (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-dzc-step'), 10));
      return;
    }
    if (t.closest('[data-dzc-remove]') && item) { Cart.change(Number(item.getAttribute('data-line')), 0); return; }
    var add = t.closest('[data-dzc-add]');
    if (add) { e.preventDefault(); Cart.add(add.getAttribute('data-dzc-add'), add); return; }
    var nav = t.closest('[data-dzc-slide]');
    if (nav && !nav.disabled) { var box = nav.closest('[data-dzc-upsells]'); goSlide(box, (box.__slide || 0) + parseInt(nav.getAttribute('data-dzc-slide'), 10)); return; }
    var tog = t.closest('[data-dzc-note-toggle]');
    if (tog) {
      var note = tog.closest('[data-dzc-note]'); var open = !note.classList.contains('is-open');
      note.classList.toggle('is-open', open); tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var ta = note.querySelector('textarea'); if (ta) ta.focus(); }
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('#DzCart [data-dzc-input]');
    if (!input) return;
    var q = parseInt(input.value, 10); if (isNaN(q)) q = 1;
    Cart.change(Number(input.closest('[data-line]').getAttribute('data-line')), q);
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('#DzCart [data-dzc-note-input]')) return;
    var v = e.target.value; clearTimeout(noteTimer); noteTimer = setTimeout(function () { saveNote(v); }, 600);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && Cart.isOpen()) Cart.close();
    if (e.key === 'Enter' && e.target.matches && e.target.matches('#DzCart [data-dzc-input]')) { e.preventDefault(); e.target.blur(); }
  });

  /* header cart icon opens the drawer (capture phase: before the theme's handler) */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a.header__cart-link, [data-header-cart]');
    if (!link || !el() || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault(); e.stopPropagation();
    Cart.lastFocus = link; Cart.open(); Cart.refresh();
  }, true);

  /* cart changes made by anything else on the page */
  var pending = null, pendingOpen = false;
  function onExternal(isAdd) {
    if (!el()) return;
    if (isAdd && performance.now() > armedAt) pendingOpen = true;
    clearTimeout(pending);
    pending = setTimeout(function () {
      var o = pendingOpen; pendingOpen = false;
      Cart.refresh().then(function () { if (o) Cart.open(); });
      refreshHeader();
    }, 120);
  }
  function urlOf(input) { return (typeof input === 'string' ? input : (input && input.url)) || ''; }
  window.fetch = function (input, init) {
    var p = baseFetch(input, init);
    try {
      var url = urlOf(input);
      if (CART_RE.test(url)) p.then(function (r) { if (r && r.ok) onExternal(/\/cart\/add/.test(url)); }).catch(function () {});
    } catch (e) {}
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this._dzcUrl = String(url || ''); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (CART_RE.test(xhr._dzcUrl || '')) xhr.addEventListener('load', function () { if (xhr.status >= 200 && xhr.status < 300) onExternal(/\/cart\/add/.test(xhr._dzcUrl)); });
    return xSend.apply(this, arguments);
  };

  function init() { var d = el(); if (d) loadRecs(d.querySelector('[data-dzc-body]')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });
})();
